import React from "react"
export function Cross(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M16.444 2.5L17.5 3.556l-6.444 6.445 6.444 6.444-1.056 1.056L10 11.056l-6.444 6.445L2.5 16.445 8.943 10 2.5 3.556 3.556 2.5 10 8.944z"
        id="prefix__cross"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
